// app/services/book/admin_extension_tokens.js
import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.ADMIN_EXTENSION_TOKENS}/${endpoint ? endpoint : ""}`

export const adminExtensionTokensService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminExtensionTokensIndexData: builder.query({
      query: (params) => ({
        url: buildUrl("index_data"),
        method: "GET",
        params,
      }),
      providesTags: ["AdminExtensionTokens"],
    }),
    getAdminExtensionTokenUser: builder.query({
      query: (userId) => ({
        url: buildUrl(`user_json/${userId}`),
        method: "GET",
      }),
      providesTags: (result, error, userId) => [{ type: "AdminExtensionTokenUser", id: userId }],
    }),
    generateAdminExtensionToken: builder.mutation({
      query: (userId) => ({
        url: buildUrl(`generate/${userId}`),
        method: "POST",
      }),
      invalidatesTags: (result, error, userId) => [
        "AdminExtensionTokens",
        { type: "AdminExtensionTokenUser", id: userId },
      ],
    }),
    revokeAdminExtensionToken: builder.mutation({
      query: (userId) => ({
        url: buildUrl(`revoke/${userId}`),
        method: "POST",
      }),
      invalidatesTags: (result, error, userId) => [
        "AdminExtensionTokens",
        { type: "AdminExtensionTokenUser", id: userId },
      ],
    }),
    revokeAdminExtensionTokenSingle: builder.mutation({
      query: ({ userId, tokenId }) => ({
        url: buildUrl(`revoke_token/${userId}/${tokenId}`),
        method: "POST",
      }),
      invalidatesTags: (result, error, { userId }) => [
        "AdminExtensionTokens",
        { type: "AdminExtensionTokenUser", id: userId },
      ],
    }),
  }),
})

export const {
  useLazyGetAdminExtensionTokensIndexDataQuery,
  useLazyGetAdminExtensionTokenUserQuery,
  useGenerateAdminExtensionTokenMutation,
  useRevokeAdminExtensionTokenMutation,
  useRevokeAdminExtensionTokenSingleMutation,
} = adminExtensionTokensService
